<div class="notification-center">
  <!-- Bell Icon with Badge -->
  <div class="notification-icon" (click)="toggleDropdown()">
    <i class="ri-notification-3-line" style="font-size: 24px;"></i>
    <span class="badge" *ngIf="activeJobsCount > 0">{{ activeJobsCount }}</span>
  </div>

  <!-- Dropdown Panel -->
  <div class="notification-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="dropdown-header">
      <h6 class="mb-0">Background Jobs</h6>
      <button class="btn btn-sm btn-link text-muted" (click)="closeDropdown()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="dropdown-body">
      <ng-container *ngIf="(jobs$ | async) as jobs">
        <!-- No Jobs -->
        <div *ngIf="jobs.length === 0" class="text-center py-4 text-muted">
          <i class="ri-inbox-line" style="font-size: 48px;"></i>
          <p class="mt-2 mb-0">No background jobs</p>
        </div>

        <!-- Job List -->
        <div *ngFor="let job of jobs" class="job-item" (click)="navigateToBatch(job.batchId)">
          <div class="d-flex align-items-start">
            <i [class]="getStatusIcon(job) + ' ' + getStatusClass(job)" 
               [ngClass]="{'spinning': job.status === 'processing' || job.status === 'pending'}"
               style="font-size: 24px; margin-right: 12px;"></i>
            
            <div class="flex-grow-1" style="min-width: 0;">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <strong>Batch #{{ job.batchId }}</strong>
                  <span class="text-muted ms-2" style="font-size: 12px;">{{ getTimeAgo(job.startedAt) }}</span>
                </div>
                <button 
                  class="btn btn-sm btn-link text-muted p-0" 
                  (click)="removeJob(job.id, $event)"
                  *ngIf="job.status === 'completed' || job.status === 'failed'">
                  <i class="ri-close-line"></i>
                </button>
              </div>

              <!-- Status Text -->
              <div class="text-muted small">
                <span *ngIf="job.status === 'pending'">Waiting to start...</span>
                <span *ngIf="job.status === 'processing'">
                  Processing {{ job.processed_jobs }} of {{ job.total_jobs }} jobs
                </span>
                <span *ngIf="job.status === 'completed'">
                  Completed: {{ job.successful_jobs }} successful, {{ job.failed_jobs }} failed
                </span>
                <span *ngIf="job.status === 'failed'">Processing failed</span>
              </div>

              <!-- Progress Bar -->
              <div class="progress mt-2" style="height: 6px;" *ngIf="job.status === 'processing' || job.status === 'pending'">
                <div 
                  class="progress-bar progress-bar-striped progress-bar-animated" 
                  [style.width.%]="getProgressPercentage(job)">
                </div>
              </div>

              <!-- Success/Failed Counts -->
              <div class="d-flex gap-3 mt-2" *ngIf="job.status === 'completed' || job.status === 'failed'">
                <span class="text-success small">
                  <i class="ri-checkbox-circle-line"></i> {{ job.successful_jobs }}
                </span>
                <span class="text-danger small" *ngIf="job.failed_jobs > 0">
                  <i class="ri-close-circle-line"></i> {{ job.failed_jobs }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="dropdown-footer" *ngIf="backgroundJobsService.getCompletedJobsCount() > 0">
      <button class="btn btn-sm btn-link text-muted w-100" (click)="clearCompleted()">
        Clear Completed
      </button>
    </div>
  </div>

  <!-- Backdrop -->
  <div class="notification-backdrop" *ngIf="isOpen" (click)="closeDropdown()"></div>
</div>
